import { GET_CHECK_GROUP_SUCCESS } from '../actions/groupActions'
export default (state = false, { type, data = false }) => {
  switch (type) {
    case GET_CHECK_GROUP_SUCCESS:
      return data
    default:
      return state
  }
}
